import React, { useState } from 'react';
import InputForm from '../../InputT';
//import "../../Assets/Styles/StyleForm.css";
import Params from '../../../Types/ParamsPicklist';
import { Box } from '@mui/material';
import { Button, Spin } from 'antd';
import Table from '../../TableResizable';
import { SwipeUp } from '@mui/icons-material';
import { useAuthHeader, useAuthUser } from '../../../Services/Auth/sessionAuth';
import Utilisateur from '../../../Models/Utilisateur';
import SearchInput from '../../SearchInput';
import { ColumnsType } from 'antd/es/table';
import axios from 'axios';
import { Crypter } from '../../../Functions/Security/Crypter';
import DataType from '../../../Types/DataTablePiclist';
import Datas from '../../../Data/Data.json'
import File from '../../File';
import DataTypeTable from '../../../Types/DataTypeTable';
import SearchModal from '../../SearchModal';
import ParamsPicklist from '../../../Types/ParamsPicklist';

const columns: ColumnsType<DataTypeTable> = [
  {
    title: 'N° Identification',
    dataIndex: 'NUMIDENTI',
  },
  {
    title: 'Type Garantie',
    dataIndex: 'typgar',
  },
  {
    title: 'Localisation',
    dataIndex: 'LOCAL',
  },
  {
    title: 'Valeur Garantie',
    dataIndex: 'VALGARANTI',
  },
  {
    title: 'Désignation',
    dataIndex: 'DESIGNATION',
  },
  {
    title: 'Date Début',
    dataIndex: 'DATDEB',
  },
  {
    title: 'Date Fin',
    dataIndex: 'DATFIN',
  },
  {
    title: 'Commentaire',
    dataIndex: 'TEXTCOMMEN',
  }
];

let searchUser:Params={CodeAgence:'',Table: "UTILIS",Colonne1:"CODUTI",Colonne2:"NOMUTI",Colagence:'001',Choix:22} 


let searchTypAdr:Params={CodeAgence:'',Table: "UTILIS",Colonne1:"CODUTI",Colonne2:"NOMUTI",Colagence:'001',Choix:22} 



//Initialisation des parametres de recherche
let searchTitre :Params={CodeAgence:'',Table: "TITRES",Colonne1:"CDTITR",Colonne2:"LIBELL1",Colagence:'101',Choix:22}
let searchSituationFamiliale :Params={CodeAgence:"SITFAM",Table: "LIB",Colonne1:"CODLIB",Colonne2:"LIBELL",Colagence:"RUBRIQ",Choix:22}
let searchProspect :Params={CodeAgence:'',Table: "DEMARC",Colonne1:"CODDMR",Colonne2:"LIBELL",Colagence:'101',Choix:22}
let searchClassRisque:Params={CodeAgence:'',Table: "CLARIS",Colonne1:"CLARIS",Colonne2:"LIBELLFR",Colagence:'101',Choix:22}
let searchPays :Params={CodeAgence:'',Table: "CDPAYS",Colonne1:"CDPAYS",Colonne2:"LIBELL",Colagence:'101',Choix:22}
let searchActivite :Params={CodeAgence:'',Table: "TABNAE",Colonne1:"CODNAE",Colonne2:"LIBELL",Colagence:'101',Choix:22}
let searchUniteInstitutionnel :Params={CodeAgence:'',Table: "TABNUI",Colonne1:"CODNUI",Colonne2:"LIBELL",Colagence:'101',Choix:22} 
let searchRegimeMatrimonial :Params={CodeAgence:"REGMAT",Table: "LIB",Colonne1:"CODLIB",Colonne2:"LIBELL",Colagence:"RUBRIQ",Choix:22}
//
let searchNiveauInstruction :Params={CodeAgence:'',Table: "INSTRU",Colonne1:"CODINS",Colonne2:"LIBELL",Colagence:'101',Choix:22} 
let searchEthnie :Params={CodeAgence:'',Table: "ETHNIE",Colonne1:"CODETH",Colonne2:"LIBELL",Colagence:'101',Choix:22} 
let searchCateGo :Params={CodeAgence:'',Table: "CATEGO",Colonne1:"CATEGO",Colonne2:"LIBELLFR",Colagence:'101',Choix:22} 
let searchZoneGeo:Params={CodeAgence:'',Table: "RESIDE",Colonne1:"CDRESI",Colonne2:"LIBELLFR",Colagence:'101',Choix:22}
let searchCpt:Params={CodeAgence:'',Table: "AGENCE",Colonne1:"plc2",Colonne2:"LIBELLE",Colagence:'101',Choix:22}
let searchGroup:Params={CodeAgence:'',Table: "GROUPUSER",Colonne1:"CODGROUP",Colonne2:"LIBELLE",Colagence:'101',Choix:22}
let searchGes:Params={CodeAgence:'',Table: "GESTIONNAIRE",Colonne1:"CODGES",Colonne2:"LIBELLE",Colagence:'101',Choix:22}
let searchService:Params={CodeAgence:'',Table: "SERVICE",Colonne1:"CODSERV",Colonne2:"LIBELLE",Colagence:'101',Choix:22}
let searchIndice:Params={CodeAgence:'',Table: "CLIENT",Colonne1:"NUMCLI",Colonne2:"NOMCLI",Colagence:'101',Choix:22}
let searchCompte:Params={CodeAgence:'',Table: "CCOMPTES",Colonne1:"NUMCPT",Colonne2:"NOMCPT",Colagence:'101',Choix:22}
let searchStatus:Params={CodeAgence:'',Table: "Status",Colonne1:"CODLIB",Colonne2:"LIBELL",Colagence:'101',Choix:22}
let searchGroupUtilis:Params={CodeAgence:'',Table: "GROUPUSER",Colonne1:"CODGROUP",Colonne2:"LIBELLE",Colagence:'101',Choix:22}
let searchGarantie:Params={CodeAgence:'',Table: "GARANTIE",Colonne1:"",Colonne2:"",Colagence:'101',Choix:3}
let searchTypeGrantie:Params={CodeAgence:'',Table: "TYPEGARANTIE",Colonne1:"codgar",Colonne2:"LIBELL",Colagence:'101',Choix:22}
let searchGarantieForm:Params={CodeAgence:'',Table: "GARANTIE",Colonne1:"codgar",Colonne2:"DESIGNATION",Colagence:'101',Choix:22}


  
function Tab1(props:{form?: any, disabled?: boolean}){
  // USER SESSION
  const auth = useAuthUser()
  const user : Utilisateur = JSON.parse(JSON.stringify(auth()))
  let searchOperat: ParamsPicklist = { CodeAgence: '', Table: "GESTIONNAIRE", Colonne1: "CODGES", Colonne2: "LIBELLE", Colagence: '001', Choix: 22 }

  // USER TOKEN
  const authHeader = useAuthHeader()

 

  // const [loading, setLoading] =React.useState(false);
  // const [loadData, setLoadData] = useState(false)

  // const ThemeTable = styled(Table)(({ theme }) => ({
    
  //   ".ant-table-body ": {
  //     height : '185px',
  //     borderBottom : '1px var(--colorOpaque020) solid',
  //   }
    
  //   }
  // ));

  


  // if (loadData) {
  //   setLoadData(false)

  //   setLoading(true);
  //   setScrool({ y:250, x:10})

  //   //var data = {CodeAgence:searchGarantie?.CodeAgence,Table:props.Parametre?.Table,Colonne1:props.Parametre?.Colonne1,Colonne2:props.Parametre?.Colonne2,Colagence:props.Parametre?.Colagence,Init:values.text,choix:props.Parametre?.Choix}
      
  //   var config = {
  //     method: 'get',
  //     maxBodyLength: Infinity,
  //     url: Datas.ApiUrl.AnySearch,
  //     headers: { 
  //       'Content-Type': 'application/json',
  //       'Authorization': authHeader(),
  //       'CipherSearch': Crypter.encrypt(JSON.stringify(searchGarantie))
  //     }
  //   }; 
  //   axios(config)
  //   .then((response)=>{
  //   console.log(response.data)
  //   if(response.data){
  //     const res = JSON.parse(Crypter.decrypt(response.data)).Value;
  //     const datat: DataTypeTable[] = [];
      
  //     if(res.StatutCode == 200){
  //       let datas = res.Result.Table;
  //       console.log(datas)
        
  //       if(datas.length===0){
  //         //console.log("aucun élément ");
  //         SetData([])
  //       }
  //       else{
  //         datas.map((data : any, indice: number)=>{
  //           //console.log(JSON.stringify(data))
  //           datat.push({
  //             key: indice,
  //             NUMIDENTI: data.NUMIDENTI,
  //             NUMCLI: data.NUMCLI,
  //             lib_NUMCLI: data.lib_NUMCLI,
  //             codgar: data.codgar,
  //             lib_codgar: data.lib_codgar,
  //             LOCAL: data.LOCAL,
  //             VALGARANTI: data.VALGARANTI,
  //             DESIGNATION: data.DESIGNATION,
  //             DATDEB: data.DATDEB,
  //             DATFIN: data.DATFIN,
  //             TEXTCOMMEN: data.TEXTCOMMEN,
  //             fichier: data.fichier,
  //           });
  //           SetData(datat);  
  //         })
  //         //setScrool(undefined)
  //       }
  //     }
  //   }
  //   setLoading(false);
  //   }).catch((error)=>{
  //     console.log(error)
  //     setLoading(false);
  //     // SweetAlert.fire({title: "Error", text : error})
  //   })
  // }
  
  return(
    <div className='tabItem'>
      <div >
        <Box fontStyle="inherit" className = 'border border-left' width={"85%"} position={"absolute"} sx={{ p: 1}}>
           <legend> Vailidation garantie </legend>
          <Box display={"flex"} fontStyle="inherit" sx={{ mb: 1 }}>
          
            <Box fontStyle="inherit" >
              <SearchInput dissabledCode={props.disabled} notRequired  width={9} form = {props.form}  Titre='Recherche Garanties'  label='Code Garantie' name='codgar' Parametre={searchGarantieForm}/>
              {/* <InputForm disabled={false} width={9} label='Numéro identific' icon={<SwipeUp fontSize='small'/>}   name='NUMIDENTI'  type='text' error='mobile' /> */}
              <SearchInput width={9}  form = {props.form}  Titre='Recherche Client'  label='Indice Client' name='NUMCLI' Parametre={searchIndice}/>
              <InputForm  width={9} label='N° identification' name='NUMIDENTI' type={'label'}/>
              <SearchModal width={9}  form = {props.form}  Titre='Recherche Type de Garantie'  label='Type Garantie' name='typgar' Parametre={searchTypeGrantie}/>
                
              <InputForm width={9} label='Désignation' placeholder='Entrez la désignation ...' type={'TextArea'} name='DESIGNATION' />
              {/* <InputForm width={6} label='Libellé' icon={<TextFields fontSize='small'/>}   name='libelle'  type='text' error='mobile' /> */}
            </Box><hr />
            <Box fontStyle="inherit" >
              {/* <SearInputM  width={4} form = {props.form}  Titre='Recherche Utilisateur'  label='Code' name='coduti' Parametre={searchUser}/> */}
              <InputForm width={9} label='Valeur Garantie' icon={<SwipeUp color='disabled' fontSize='small'/>}   name='VALGARANTI'  type='number' error='mobile' />
              <InputForm width={9} label='Localisation' icon={<SwipeUp color='disabled' fontSize='small'/>}   name='LOCAL'  type='TEXT' error='mobile' />
              <InputForm width={9} label='Date début' icon={<SwipeUp color='disabled' fontSize='small'/>}   name='DATDEB'  type='date' error='mobile' />
              <InputForm width={9} label='Date fin' icon={<SwipeUp color='disabled' fontSize='small'/>}   name='DATFIN'  type='date' error='mobile' />
              <InputForm width={9} label='Commentaire' placeholder='Entrez un commentaire ...' type={'TextArea'} name='TEXTCOMMEN' />
              {/* <SearchInput width={8} form = {props.form}  Titre='Recherche Code Opération'  label='Code opértion' name='codope' Parametre={searchGroupUtilis}/> */}
              {/* <SearchInput width={8} form = {props.form}  Titre='Recherche Groupe Utilisateur'  label='Cpte Client HB' name='codClientHB' Parametre={searchGroupUtilis}/>
              <SearchInput width={8} form = {props.form}  Titre='Recherche Groupe Utilisateur'  label='Cpte Général HB' name='codGeneralHB' Parametre={searchGroupUtilis}/> */}
            </Box>
            <hr />
            
            <Box fontStyle="inherit" >
              {/* <SearInputM  width={4} form = {props.form}  Titre='Recherche Utilisateur'  label='Code' name='coduti' Parametre={searchUser}/> */}
              <File label='Pièce Jointe' name='fichier' form={props.form}/><br />
              {/* <InputForm width={6} label='Libellé' icon={<TextFields fontSize='small'/>}   name='libelle'  type='text' error='mobile' /> */}
            </Box>
          </Box>
           <SearchInput notRequired width={3}  dissabledCode form={props.form} dissabledLib={false} Titre={'Operation'} label={"Operation"} name={"Operation"} Parametre={searchOperat} />
        </Box>
      </div>
    </div>
  )
}

export default Tab1;  
